import {WordEntry} from "../../WordEntry";
import * as React from "react";
import {Util} from "../../Util";
import japanese from "japanese";
import {Action} from "../App";
import {KanaDisplay} from "./KanaDisplay";
import styled from "styled-components";
import {Button, Container, Icon} from "semantic-ui-react";
import {StyledQuizCard} from "./StyledQuizCard";
import {ActionDisplay} from "./ActionDisplay";
import {AudioButton} from "./AudioButton";
import {StyledGlossaryEntries} from "./StyledGlossaryEntries";
import {KanjiDisplay} from "./KanjiDisplay";

interface AnswerProps {
    action: Action,
    word: WordEntry,
    showLanguageError: {(): void},

    record(correct: boolean): void
}

interface AnswerState {
}

export class Answer extends React.Component<AnswerProps, AnswerState> {
    public render() {
        if (this.props.action !== Action.reveal) {
            return "";
        }

        return (
            <StyledQuizCard>
                <KanaDisplay className="reading">
                    {this.props.word.reading}
                </KanaDisplay>
                <Transliteration className="transliteration">
                    {japanese.romanize(this.props.word.reading)} <AudioButton onClick={() => Util.playSound(this.props.word.reading, this.props.showLanguageError)}><Icon name={"caret square right"}/></AudioButton>
                </Transliteration>
                <KanjiDisplay entry={this.props.word}/>
                <StyledGlossaryEntries glossaryEntries={this.props.word.glossary}/>
                <ActionDisplay>
                    Did you get this right?
                    <Container>
                        <Button compact size='big' onClick={() => this.props.record(true)}>Yes</Button>
                        <Button compact size='big' onClick={() => this.props.record(false)}>No</Button>
                    </Container>
                </ActionDisplay>
            </StyledQuizCard>
        )
    };
}

const Transliteration = styled.p`
  font-size: 1.5em;
`;



// WEBPACK FOOTER //
// ./src/components/QuizBox/Answer.tsx